import { render, staticRenderFns } from "./Carpo.vue?vue&type=template&id=b7eef1c6&scoped=true&"
var script = {}
import style0 from "./Carpo.vue?vue&type=style&index=0&id=b7eef1c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eef1c6",
  null
  
)

export default component.exports